import React from "react";
import { Testimonial_Item } from "../TestimonialItem";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, Navigation } from "swiper";
SwiperCore.use([Autoplay, Navigation]);
export const Testimonials_Section = ({ items }) => {
  return (
    <div className="container testimonials-section">
      <div className="divider"></div>
      <div className="divider"></div>
      <div className="testimonials">
        <h1 className="section-title text-center fw-500">Testimonials</h1>
        <div className="py-5">
          <Swiper
            loop
            centeredSlides={false}
            autoplay={{ delay: 2500, disableOnInteraction: false }}
            navigation
            slidesPerView={1}
            spaceBetween={0}
            breakpoints={{
              700: {
                slidesPerView: 2,
                spaceBetween: 30,
              },
            }}
          >
            {items.map((item) => (
              <SwiperSlide key={item.id}>
                <Testimonial_Item
                  name={item.name}
                  text={item.text}
                  pic={item.pic}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
};
